import { motifConsts } from "../../cadendar-consts.js";
import { RecommendationSettingsSchema, } from "../../types/zodSchemas.js";
export function getDefaultRecommendationSettings() {
    return RecommendationSettingsSchema.parse({
        version: 1,
        scoring: {
            exactFit: { enabled: true, score: 10 },
            beginningOfFreePeriod: { enabled: true, score: 5 },
            smallResidualGap: { enabled: true, score: -20 },
            regularResidualGaps: { enabled: true, multipleOfMinutes: 30, score: 5 },
            preferredEndTimes: [
                { enabled: true, endMinute: 17 * 60, score: 15 },
                { enabled: true, endMinute: 12 * 60 + 45, score: 5 },
            ],
            adjacentAppointment: { enabled: true, score: 10 },
        },
        durationProfiles: {
            cadendar: {
                defaultDuration: 30,
                multiplePatients: { enabled: true },
                minor: { enabled: true, maxAge: 17, duration: "minimum" },
                existingPatientShortMotifs: {
                    enabled: true,
                    motifs: [motifConsts.CTRL, motifConsts.DET, motifConsts.DDS],
                    duration: "minimum",
                },
            },
            cadenweb: {
                newPatientAdult: { enabled: true, duration: 30 },
                newPatientMinor: { enabled: true, maxAge: 17, duration: 15 },
                shortMotifs: {
                    enabled: true,
                    motifs: [motifConsts.CTRL, motifConsts.DET],
                    duration: 15,
                },
                brokenTooth: {
                    enabled: true,
                    motif: motifConsts.DKCTROU,
                    duration: 30,
                },
            },
        },
        postponement: {
            enabled: true,
            thresholdHours: 48,
            delayWeeks: 2,
        },
        tieBreaking: {
            enabled: true,
            refreshHours: 1,
        },
        presentation: {
            cadendar: { filterByMinimumScore: true, minimumScore: 0 },
            cadenweb: {
                candidatesPerDay: 3,
                candidatesPerDayWhenEvening: 1,
                automaticSearchWeeks: 10,
                selectOnlyCandidate: true,
            },
        },
    });
}
export function getInvalidRecommendationDuration(settings, minimumDuration) {
    const durations = [
        settings.durationProfiles.cadendar.defaultDuration,
        ...(settings.durationProfiles.cadenweb.newPatientAdult.enabled
            ? [settings.durationProfiles.cadenweb.newPatientAdult.duration]
            : []),
        ...(settings.durationProfiles.cadenweb.newPatientMinor.enabled
            ? [settings.durationProfiles.cadenweb.newPatientMinor.duration]
            : []),
        ...(settings.durationProfiles.cadenweb.shortMotifs.enabled
            ? [settings.durationProfiles.cadenweb.shortMotifs.duration]
            : []),
        ...(settings.durationProfiles.cadenweb.brokenTooth.enabled
            ? [settings.durationProfiles.cadenweb.brokenTooth.duration]
            : []),
    ];
    return durations.find((duration) => duration % minimumDuration !== 0);
}
//# sourceMappingURL=recommendationSettings.js.map